export function cloneObject(data: any): any {
  if (structuredClone) {
    return structuredClone(data);
  }
  return JSON.parse(JSON.stringify(data));
}
